"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
/**
 * useModal hook to handle common modal plumbing
 * @param type
 * @returns {{isOpen: boolean, clear: (function(): any)}}
 */
function useModal(type, clearModal) {
  var dispatch = (0, _reactRedux.useDispatch)();
  function clear() {
    dispatch(clearModal(type));
  }
  var _ref = (0, _reactRedux.useSelector)(function (_ref2) {
      var modal = _ref2.modal;
      return modal;
    }) || {},
    currentType = _ref.type,
    initialValue = _ref.initialValue;
  var isOpen = currentType ? currentType === type : false;
  return {
    clear: clear,
    isOpen: isOpen,
    initialValue: initialValue
  };
}
var _default = exports["default"] = useModal;